Object.assign(exports, require('./fetch-adapter'))
Object.assign(exports, require('./pouchdb-adapter'))
